import Image from "next/image";
import { getStrapiMediaArr } from "utils";

// These are the verified agency-badge media from the EN/NL/TR CMS records.
// Keep other customer/technology logos unchanged.
const agencyBadgeFiles = new Set([
  "Middel_2_98a1f582c2.svg",
  "logo_shopify_partner_bd911f79ae.svg",
  "logo_shopify_expert_d98fc87e24.svg",
  "Badge_Premier_wht_transp_Large_602c6fb28d.png",
]);

interface PartnerLogo {
  id: number;
  attributes: { url?: string; alternativeText?: string };
}

interface PartnerLogosProps {
  logos: PartnerLogo[];
  logoScale?: number;
  compact?: boolean;
}

function isAgencyPartnerLogo(item: PartnerLogo) {
  const filename = item.attributes.url?.split("/").pop();
  return !!filename && agencyBadgeFiles.has(filename);
}

export default function PartnerLogos({ logos, logoScale = 100, compact = false }: PartnerLogosProps) {
  const firstPartnerIndex = logos.findIndex(isAgencyPartnerLogo);

  return (
    <div className="logos-row">
      {logos.map((item, index) => {
        if (isAgencyPartnerLogo(item)) {
          if (index !== firstPartnerIndex) return null;
          return (
            <Image
              key="shopify-premier-partner"
              src="/shopify-premier-partner.png"
              alt="Shopify Premier Partner"
              width={524}
              height={232}
              sizes="122px"
              loading="eager"
              style={{ width: "121.6px", height: "auto" }}
            />
          );
        }

        return (
          <Image
            key={item.id}
            src={getStrapiMediaArr(item)}
            alt={item.attributes.alternativeText || ""}
            width={152}
            height={25}
            style={compact
              ? { width: "125px", height: "25px" }
              : { width: `${(logoScale * 152) / 100}px`, height: "auto" }}
          />
        );
      })}
    </div>
  );
}
